<template>
  <div>
    <index-navbar />
    <section
      class="header relative pt-20 xl:mt-20 items-center flex h-screen xsm:h-screen-custom xxsm:h-screen-custom max-h-860-px"
    >
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
          <div class="mobilep pt-24 sm:pt-0 md:pt-16">
            <h2 class="text-3xl text-white">
              <span class="text-white far fa-check-square text-bgbb-y"></span>
              Decentralized <br />

              <span class="text-white far fa-check-square text-bgbb-y"></span>
              Fairly Launched <br />

              <span class="text-white far fa-check-square text-bgbb-y"></span>
              Automatically Liquid <br />

              <span class="text-white far fa-check-square text-bgbb-y"></span>
              Trustlessly Exchangeable <br />

              <span class="text-white far fa-check-square text-bgbb-y"></span>
              Interest-Bearing <br />
            </h2>

            <p class="mt-4 text-lg leading-relaxed text-white text-justify">
              <span class="text-bgbb-y">
                <strong>BOND-LIKE TOKEN.</strong>
              </span>
              BGBB is an innovative cryptocurrency designed to be a highly
              secure store of value that you can easily stake to earn trustless
              interest. Like bonds, certificates of deposit, and time deposit
              bank accounts, longer stakes provide higher yields.

              <br />
              <strong>
                The BGBB smart contract ensures you always have full custody and
                control over your BGBB tokens, even during unexpected economic
                or political activities.
              </strong>
            </p>
            <div class="mt-12 mb-24 "></div>
          </div>
        </div>
      </div>




      
    </section>


    

    <section class="pb-40 relative block bg-bgbb-y">




<div class="custom-shape-divider-top-1623844337">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M602.45,3.86h0S572.9,116.24,281.94,120H923C632,116.24,602.45,3.86,602.45,3.86Z" class="shape-fill"></path>
    </svg>
</div>





      <div class="container mx-auto px-4 lg:pt-24 lg:pb-16">
        <div class="flex flex-wrap text-center justify-center">
          <div class="w-full lg:w-6/12 px-4">
            <h2 class="text-3xl mobile:pt-40 pt-32">
              KEY FEATURES <br />
              that make the BGBB project unique
            </h2>
          </div>

          <!-- ROW I -->
        </div>
        <div class="flex flex-wrap mt-24 justify-center">
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-shield-alt text-5xl "></i>
            </div>
            <h5 class="text-2xl mt-5">Ownerless Liquidity</h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              The BGBB contract will lock the presale ADA into the market
              permanently by burning the issued liquidity tokens.
            </p>
          </div>
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 rounded-full inline-flex items-center justify-center"
            >
              <i class="fas fa-gem text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5 ">Backed By ADA</h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              A pool of ADA on SundaeSwap will back all BGBB holders, who can
              choose to cash out at any time.
            </p>
          </div>
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-sort-numeric-up-alt text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5">Rising Price Floor</h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              The value of BGBB's ADA pool will grows as investors and traders
              buy and sell BGBB from SundaeSwap. Fees stay in the pool.
            </p>
          </div>
        </div>

        <!-- ROW I END -->

        <!-- ROW II  -->

        <div class="flex flex-wrap mt-24 justify-center">
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-hand-holding-usd text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5">Fairly Distributed</h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              The BGBB contracts are completely locked, and neither the team nor
              the admins can change them. It is entirely 100% decentralized.
            </p>
          </div>
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 rounded-full inline-flex items-center justify-center"
            >
              <i class="fas fa-rocket text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5">Fair Launch</h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              The BGBB contract locks the presale funds into the pool and
              automatically manages liquidity for community profits.
            </p>
          </div>
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-globe text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5">100% Decentralized</h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              NO team tokens & NO admin keys. No more trusting banks and
              governments to stay solvent and not change their rules. No more
              worrying that a bond issuer may default on you. BGBB is pure,
              immutable code.
            </p>
          </div>
        </div>

        <!-- ROW II end -->

        <!-- ROW III -->

        <!-- ROW III END -->

        <!-- ROW IV -->

        <!-- ROW III -->

        <!-- ROW IV END -->
      </div>

    <div class="custom-shape-divider-bottom-1623846473">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M602.45,3.86h0S572.9,116.24,281.94,120H923C632,116.24,602.45,3.86,602.45,3.86Z" class="shape-fill"></path>
    </svg>
</div>




    </section>

    <!-- BGBB TOKEN UTILITY -->

    


<!-- pt-50 pb-40  -->

    <section class="pb-32 pt-12 ">



    <div class="flex flex-wrap text-center justify-center mt-12">
      <div class="w-full lg:w-6/12 px-4 pb-10">
        <h2 class="text-3xl text-white">BGBB Token Utility</h2>
      </div>
    </div>


      <div class="container mx-auto px-4">
        <div class="flex flex-wrap">
          <div class="w-full md:w-4/12 px-4 text-center">
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
            >
              <div class="px-4 py-5 flex-auto">
                <h3>#1</h3>
                <br />

                <!-- <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-bgbb-1"
                  >
                    <i class="fas fa-percent"></i>
                  </div> -->
                <h6 class="text-xl">Staking & Rewards</h6>
                <p class="mt-2 mb-4 text-gray-600">
                  Yields generated from staking and referral rewards will be
                  paid in BGBB.

                  <br />
                  <br />

                  <a href="#stakebgbb" target="_self"> Read More </a>
                </p>
              </div>
            </div>
          </div>

          <div class="w-full md:w-4/12 px-4 text-center">
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
            >
              <div class="px-4 py-5 flex-auto">
                <!-- <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-bgbb-2"
                  >
                    <i class="fas fa-retweet"></i>
                  </div> -->

                <h3>#2</h3>
                <br />

                <h6 class="text-xl">Governance</h6>
                <p class="mt-2 mb-4 text-gray-600">
                  The BGBB protocol will be governed by the BGBB token-holders.

                  <br />
                  <br />

                  <a href="#governance" target="_self"> Read More </a>
                </p>
              </div>
            </div>
          </div>

          <div class="w-full md:w-4/12 px-4 text-center">
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
            >
              <div class="px-4 py-5 flex-auto">
                <!-- <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-bgbb-3"
                  >
                   
                      <i class="fas fa-file-contract text-gray-900"></i>
                  </div> -->

                <h3>#3</h3>
                <br />

                <h6 class="text-xl">NFT Minting & Trading</h6>
                <p class="mt-2 mb-4 text-gray-600">
                  Buy, sell and mint your NFT on the open BGBB NFT marketplace
                  using BGBB tokens.

                  <br />
                  <br />
                  <a href="#nftminting" target="_self"> Read More </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>


  










 <section class="pt-50 pb-40 relative block bg-bgbb-y">


<div class="custom-shape-divider-top-1623844337">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M602.45,3.86h0S572.9,116.24,281.94,120H923C632,116.24,602.45,3.86,602.45,3.86Z" class="shape-fill"></path>
    </svg>
</div>

  <div class="container mx-auto px-4 pb-8">
        <div class="flex flex-wrap text-center justify-center">
          <div class="w-full lg:w-8/12 px-4">
            <h2 class="text-2xl">
              Don't Trust Us?
            </h2>
            <p class="text-lg leading-relaxed mt-6 mb-12">
              You don't have to! There is a trustless way to verify this
              information through the public Cardano explorer:
            </p>
          </div>
        </div>

        <div class="container mx-auto px-4 lg:pb-16">
          <div class="flex flex-wrap text-center justify-center">
            <a
              href="#"
              target="_self"
              class="shadow-xl get-started font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-dark-bgbb100 uppercase text-sm"
            >
              CHECK On Cardanoscan <i class="fas fa-long-arrow-alt-right"></i>
            </a>

            <a
              href="#"
              class="shadow-xl github-star ml-1 font-semibold text-dark px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-white uppercase text-sm"
              target="_self"
            >
              CHECK ON SundaeSwap <i class="fas fa-long-arrow-alt-right"></i>
            </a>
          </div>

          <div class="container mx-auto px-4 pb-8">
            <div class="flex flex-wrap text-center justify-center">
              <div class="w-full lg:w-8/12 px-4">
                <p class="text-lg leading-relaxed mt-6 mb-12">
                  (will be available after launch)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


 <div class="custom-shape-divider-bottom-1623846473">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M602.45,3.86h0S572.9,116.24,281.94,120H923C632,116.24,602.45,3.86,602.45,3.86Z" class="shape-fill"></path>
    </svg>
</div>


</section>














    <footer-component />
  </div>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";

import FooterComponent from "@/components/Footers/Footer.vue";

import documentation from "@/assets/img/documentation.png";
import NFT1_img from "@/assets/img/Government_Bond_282781.jpg";
import NFT2_img from "@/assets/img/Government_Bond_057187.png";
import NFT3_img from "@/assets/img/Government_Bond_056737.png";


export default {
  data() {
    return {
      documentation,
      NFT1_img,
      NFT2_img,
      NFT3_img,
    };
  },
  components: {
    IndexNavbar,
    FooterComponent,
  },


};
</script>
